// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vant from 'vant'
import 'vant/lib/index.css'
import {Button, Form, FormItem, Input, Image, Loading} from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import store from './store/store'
import iconSvg from './components/common/iconSvg'
import './assets/icon/iconfont'
import jsonp from 'vue-jsonp'
import router from './router'
import App from './App'

Vue.use(Vant)
Vue.use(Button)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(Image)
Vue.use(Loading)
Vue.use(jsonp)
Vue.config.productionTip = false
Vue.component('icon-svg', iconSvg)

/* eslint-disable no-new */
let global = new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})

export default global



// WEBPACK FOOTER //
// ./src/main.js